import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}> 
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function FlatEmbroideryDigitizing() {

    const flatSteps = [
        { number: "01", title: "Submit Your Design", description: "Provide your logo or artwork in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "Flat Embroidery Digitizing", description: "Our experts convert your design into an optimized stitch file for flat embroidery.", icon: "⚡" },
        { number: "03", title: "Quality Check", description: "We refine stitch density, directions, and paths to ensure professional results.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery files in formats like DST, PES, JEF, and EXP.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Flat Embroidery Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Professional flat embroidery digitizing services in Los Angeles, CA. Clean, precise stitch files for logos and apparel. Fast and affordable service." />
                <meta name="keywords" content="flat embroidery digitizing, standard embroidery digitizing, flat stitch embroidery digitizing, embroidery digitizing services Los Angeles, embroidery digitizing near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Flat Embroidery Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Flat Embroidery Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/flatemb1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Clean. Crisp. Professional.</span>
                                <h3 className="case-study-title">Professional Flat Embroidery Digitizing in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we provide expert flat embroidery digitizing services in Los Angeles, California, designed to deliver clean, precise, and professional stitch files for all types of garments and promotional products. Flat embroidery is the most common style of embroidery and requires careful attention to stitch type, density, and design placement to achieve smooth, professional results.
                                </p>
                                <p className="case-study-description">
                                    Our team converts logos, artwork, and graphics into high-quality embroidery files that work seamlessly on all major embroidery machines. Whether your design is simple or complex, our flat embroidery digitizing services ensure your final product looks sharp, consistent, and visually appealing. If you’re searching for reliable flat embroidery digitizing near you in Los Angeles, Grand Indigo Embroidery provides fast, accurate, and affordable solutions.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Optimized for Smooth Production</span>
                                <h3 className="case-study-title">Custom Flat Logo Digitizing for Apparel & Branding</h3>
                                <p className="case-study-description">
                                    Our flat logo digitizing services are tailored to businesses, brands, and embroidery professionals who want consistent, high-quality results. We optimize every stitch for your fabric type and placement, ensuring minimal thread breaks and smooth execution across your garments.
                                </p>
                                <p className="case-study-description">
                                    From small chest logos to large designs for jackets or uniforms, we create embroidery files ready for production. Businesses in Los Angeles trust Grand Indigo Embroidery for precise flat embroidery digitizing that maintains the integrity of their designs. You can also order flat embroidery digitizing online and receive professionally optimized files quickly and efficiently.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/flatemb2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={flatSteps} />
            
            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is flat embroidery digitizing?"
                                    answer="Flat embroidery digitizing is the process of converting a design into a machine-readable stitch file for standard embroidery, producing smooth and precise results on garments."
                                />

                                <FaqItem
                                    question="Do you provide flat embroidery digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery offers professional flat embroidery digitizing services in Los Angeles, California, for local and online clients."
                                />

                                <FaqItem
                                    question="How long does flat embroidery digitizing take?"
                                    answer="Most orders are completed within 12–24 hours depending on the complexity of your design."
                                />

                                <FaqItem
                                    question="Can I order flat embroidery digitizing online?"
                                    answer="Absolutely. You can order flat embroidery digitizing online and receive your files quickly with fast turnaround."
                                />

                                <FaqItem
                                    question="What types of designs can be digitized for flat embroidery?"
                                    answer="We can digitize logos, text, monograms, patches, and artwork of all sizes for flat embroidery applications."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
